import React from 'react';
import { useRouter } from 'next/router';

import { App as BaseApp } from '@annunciate/web/dist/components/App';

import { CUSTOM_THEME } from '@/theme';
import { client } from '@/queryClient';

export interface LayoutProps {
  dehydratedState?: any;
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({
  children,
  dehydratedState = {},
}) => {
  const router = useRouter();

  return (
    <BaseApp
      theme={CUSTOM_THEME}
      client={client}
      dehydratedState={dehydratedState}
      onNavigate={async (link: string) => {
        if (link === 'back') {
          router.back();
        } else {
          router.push(link);
        }
      }}
    >
      {children}
    </BaseApp>
  );
}
